import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import arTranslations from '../assets/locales/ar.json'
import deTranslations from '../assets/locales/de.json'
import enTranslations from '../assets/locales/en.json'
import esTranslations from '../assets/locales/es.json'
import frTranslations from '../assets/locales/fr.json'
import trTranslations from '../assets/locales/tr.json'

i18n.use(initReactI18next).init({
    resources: {
        de: {
            translation: deTranslations,
        },
        en: {
            translation: enTranslations,
        },
        ar: {
            translation: arTranslations,
        },
        fr: {
            translation: frTranslations,
        },
        es: {
            translation: esTranslations,
        },
        tr: {
            translation: trTranslations,
        },
    },
    lng: 'de',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
})

export default i18n
